module.exports = __webpack_public_path__ + "static/media/drumnow-1.6662fd26.jpg";